import {
  createSlice,
  createAsyncThunk,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
import http from "../../utils/axios";

// Fetch company details
export const fetchCompanyDetails = createAsyncThunk(
  "companyDetails/fetchCompanyDetails",
  async () => {
    const res = await http.get("/dashboard/company-details");
    return res;
  }
);

// Store or update company details
export const storeOrUpdateCompanyDetails = createAsyncThunk(
  "companyDetails/storeOrUpdateCompanyDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await http.post("/dashboard/company-details", payload);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to save company details"
      );
    }
  }
);

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState: {
    companyDetails: null,
    companyDetailsFetchStatus: "idle",
    companyDetailsSaveStatus: "idle",
    loading: false,
    error: null,
  },
  reducers: {
    resetCompanyDetailsStatuses: (state) => {
      state.companyDetailsSaveStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch company details
      .addCase(fetchCompanyDetails.pending, (state) => {
        state.companyDetailsFetchStatus = "loading";
        state.loading = true;
      })
      .addCase(fetchCompanyDetails.fulfilled, (state, action) => {
        state.companyDetailsFetchStatus = "success";
        state.companyDetails = action.payload?.data || null;
        state.loading = false;
      })
      .addCase(fetchCompanyDetails.rejected, (state, action) => {
        state.companyDetailsFetchStatus = "failed";
        state.loading = false;
        state.error = action.error.message;
      })

      // Store or update company details
      .addCase(storeOrUpdateCompanyDetails.pending, (state) => {
        state.companyDetailsSaveStatus = "loading";
        state.loading = true;
      })
      .addCase(storeOrUpdateCompanyDetails.fulfilled, (state, action) => {
        state.companyDetailsSaveStatus = "success";
        state.companyDetails = action.payload?.data || null;
        state.loading = false;
      })
      .addCase(storeOrUpdateCompanyDetails.rejected, (state) => {
        state.companyDetailsSaveStatus = "failed";
        state.loading = false;
      })

      .addMatcher(isPending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addMatcher(isFulfilled, (state) => {
        state.loading = false;
      })
      .addMatcher(isRejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetCompanyDetailsStatuses } = companyDetailsSlice.actions;
export default companyDetailsSlice.reducer;
